import styled from 'styled-components';

export const CreateNewProjectStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
`;
